import React, { useEffect } from "react";

function useTitle(title) {
  useEffect(() => {
    document.title = `${title} - Alibaba`;
  }, [title]);
}

export default useTitle;
